import React from 'react'
import hotelLocationPages from '../../../../config/hotelLocationPages'
import ProductSelect from './productSelect.jsx'

const HotelSelect = ({id, label = 'Select your airport hotel'}) => (
  <ProductSelect id={id} label={label} options={hotelLocationPages} />
)

export default HotelSelect



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/dropdowns/hotelselect.jsx